import { createSignal } from '@pexip/signal';
import { getCurrentHref as getHref } from './location';
import { createHistory } from './history';
/**
 * A factory function to create Router object, @see Router
 *
 * @param options - Options to set the dependencies of the router, e.g. `baseUri`
 */
export const createRouter = ({ getCurrentHref = getHref, baseUri = '/', ...options } = {}) => {
    const urlRequestSignal = options.urlRequestSignal ??
        createSignal({
            name: 'router:urlRequest',
        });
    const urlChangedSignal = options.urlChangedSignal ??
        createSignal({
            name: 'router:urlChanged',
        });
    const history = createHistory(urlRequestSignal.emit);
    return {
        get currentHref() {
            return getCurrentHref();
        },
        get baseUri() {
            return baseUri;
        },
        urlChangedSignal,
        urlRequestSignal,
        history,
    };
};
//# sourceMappingURL=router.js.map